import type { Store } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import { CHAT_APP_ID } from '../common/constants';
import type { State } from '../model/types';
import type { Action } from './actions';
import rootReducer, { createInitialState } from './reducer';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	rootEpic: Epic<Action, State>,
	baseUrl: BaseUrl,
	environment: string,
): Store<State> =>
	initiateStore<State, Action, undefined>({
		appName: CHAT_APP_ID,
		// @ts-expect-error - TS2322 - Type '(state: State, action: Action) => State' is not assignable to type 'Reducer<State>'.
		rootReducer,
		initialState: createInitialState(baseUrl, environment),
		rootEpic,
	});
